import { differenceInDays } from 'date-fns';

export const isOverDue = (dueDate: string): boolean => {
   const startOfToday = new Date(new Date().setHours(0, 0, 0, 0));

   return startOfToday >= new Date(dueDate);
};
export const calculateOverDueDays = (dueDate: string): number => {
   if (!isOverDue(dueDate)) {
      return 0;
   }

   return differenceInDays(new Date(), dueDate);
};
